import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Chip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { DocumentStatusChip } from 'app/domains/documents';
import { DocumentIdChip } from './DocumentIdChip';
import { useDocumentMetadata } from './DocumentMetadataProvider';
import { CompanyMetadataConfig } from './DocumentMetadataProvider/useGetDocumentMetadata/config';
import { DocumentNameChip } from './DocumentNameChip';
import { TemplateCategory } from './TemplateCategory';
export function SystemMetadataList() {
    const { data, documentId } = useDocumentMetadata();
    const { systemData } = data;
    const { createdAt, createdBy, templateName, updatedAt, status, type, dateSigned } = systemData;
    return (<Fragment>
      <DocumentIdChip id={documentId}/>

      <DocumentNameChip />

      <DocumentStatusChip documentId={documentId} status={status} type={type} size="medium" appearance="secondary" variant="solid" label={t({
            message: 'Document Status',
            comment: 'Metadata sidebar: Label for document status',
        })} icon={<Falcon icon="plus"/>} secondary={dateSigned}/>

      {templateName && (<Chip size="medium" appearance="secondary" icon={<Falcon icon="lock"/>} label={t({ message: 'Template', comment: 'Label for document template' })} secondary={templateName}/>)}

      <Chip size="medium" appearance="secondary" icon={<Falcon icon="lock"/>} label={t({ message: 'Created at', comment: 'Label for document creation date' })} secondary={createdAt}/>

      <Chip size="medium" appearance="secondary" icon={<Falcon icon="lock"/>} label={t({ message: 'Updated at', comment: 'Label for document last update date' })} secondary={updatedAt}/>

      <Chip size="medium" appearance="secondary" icon={<Falcon icon="lock"/>} label={t({ message: 'Created by', comment: 'Label for document creator' })} secondary={createdBy}/>

      <CompanyMetadataConfig>
        <TemplateCategory />
      </CompanyMetadataConfig>
    </Fragment>);
}
